const general = () => {

    document.addEventListener('DOMContentLoaded', function (){
        const container = document.querySelector('.fndry-grid-location')
        if(container){
            const paragraphs = container.querySelectorAll('.fndry-paragraph')
            paragraphs.forEach((p, index) => {
                if(p.querySelector('br')){
                    p.innerHTML = p.innerHTML.replace(/<br\s*\/?>/gi, '');
                }
            })        
        }
        
        
        // Redirect users to previous page
        const button = document.querySelector('.fndry-btn--history-back')
    
        if(button){
            button.addEventListener('click', function(event){
                window.history.back();
            })
        }

        // Add quotations to Post title in News Category Archives (acts as a Search Result message)
        const categoryTitle = document.querySelector(".fndry-category");
        if(categoryTitle){
            categoryTitle.textContent = `"${categoryTitle.textContent}"`;
        }

        if (window.location.pathname.endsWith('/all-programs/')) {
            const allProgramsBtn = document.querySelector('.fndry-btn-allProgramsButton');
            if (allProgramsBtn) {
                allProgramsBtn.style.display = 'none';
            }
        }



    })
}

export default general;